import { render, staticRenderFns } from "./WagonListManovreView.vue?vue&type=template&id=32517852&scoped=true"
import script from "./WagonListManovreView.vue?vue&type=script&lang=js"
export * from "./WagonListManovreView.vue?vue&type=script&lang=js"
import style0 from "./WagonListManovreView.vue?vue&type=style&index=0&id=32517852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32517852",
  null
  
)

export default component.exports